import styled from "@emotion/styled";

export const StyledList = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    maxHeight: 384,
}));

export const RadioItem = styled("div")(({ theme }) => ({
    marginBottom: theme.spacing(0.91),
}));
